var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBadgeCheckIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#badgeCheckIcon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.297 8.203c.44.44.44 1.153 0 1.59l-6 6.004a1.12 1.12 0 0 1-1.59 0l-3-3a1.125 1.125 0 0 1 1.59-1.59l2.203 2.204 5.203-5.208a1.12 1.12 0 0 1 1.589 0h.005Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 0a4.5 4.5 0 0 1 3.98 2.395 4.5 4.5 0 0 1 5.625 5.625A4.5 4.5 0 0 1 24 12a4.5 4.5 0 0 1-2.395 3.98 4.5 4.5 0 0 1-5.625 5.625A4.5 4.5 0 0 1 12 24a4.5 4.5 0 0 1-3.98-2.395 4.497 4.497 0 0 1-4.504-1.12 4.5 4.5 0 0 1-1.12-4.505A4.5 4.5 0 0 1 0 12a4.5 4.5 0 0 1 2.395-3.98 4.497 4.497 0 0 1 1.12-4.504 4.5 4.5 0 0 1 4.505-1.12A4.5 4.5 0 0 1 12 0Zm5.297 9.797a1.125 1.125 0 0 0-1.59-1.59l-5.202 5.204-2.203-2.203a1.125 1.125 0 0 0-1.59 1.59l3 2.999c.441.44 1.154.44 1.59 0l5.995-6Z",
  opacity: 0.4
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "badgeCheckIcon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})))));
export default SvgBadgeCheckIcon;